<template lang="pug">
div  
        .card-body.bg-light
            .form-row
                .col-md-7
                    label Nombre Division
                    input.form-control.form-control-sm(v-model="parameter.DivisionName", @keypress.enter="sendSearch()")
                .col-md-3
                    label Estado
                    select.form-control.form-control-sm(v-model="parameter.Active" )
                        option(value=1) Activa
                        option(value=0) Inactiva
                        option(value=2) Todos
                .col-md-2
                    label 
                    button.btn.btn-primary.text-light.btn-block(@click="sendSearch()") Buscar 
                        i.fa.fa-search  
        .card-body.bg-light    
            .form-group
                    table.table.table-sm.table-borderedonlytable
                        thead.bg-table.text-white
                            th Editar   
                            th Nombre Division
                            th Estado                      
                        tbody.bg-white(name="table-fade", is="transition-group") 
                             tr(v-if="",v-bind:key="index" v-for="(item,index) in tablaInfo")

                                td
                                    button.btn.btn-sm.btn-info(@click="sendInfo(item)")  
                                        i.fa.fa-edit 
                                td {{item.DivisionName}} 
                                td {{item.Active==1 ? 'Activo':'Inactivo'}}

</template>
<script> 
export default {
    props:{
        tablaInfo:Array,
        parameter:Object
    }, 
    methods:{ 
            sendSearch(){ 
                this.$emit("update:parameter",this.parameter) 
                this.$emit("sendSearch",this.parameter) 
            },
            sendInfo(item){  
                this.$emit("sendInfo", Object.assign({}, item)) 
            },
            sendInfoDinamic(item){  
                this.$emit("sendInfoDinamic", Object.assign({}, item)) 
            }
    }
}
</script>
<style>
    .table-fade-enter-active {
      transition: all .5s ease;
    }
    .table-fade-leave-active {
      transition: all .5s ease;
    }
    .table-fade-enter, .table-fade-leave-to{
      transform: translateY(-20px);
      opacity: 0;
    } 
</style>